// extracted by mini-css-extract-plugin
module.exports = {"container":"QuoteInfo_container__2m5fC","info":"QuoteInfo_info__1Z3_0"};